import React from "react";
import Button from "../../Button/Button";

import classes from "./RadioButtonOption.module.scss";
import { ETranslation } from "../../../../translations/translation-keys";
import { useTranslation } from "react-i18next";

interface IProps {
  value: string;
  label?: string;
  labelTranslation?: ETranslation;
  isActive: boolean;
  disabled?: boolean;
  invalid?: boolean;
  onClick: (value: string) => void;
}

const RadioButtonOption: React.FC<IProps> = ({
  value,
  label,
  labelTranslation,
  isActive,
  disabled,
  onClick,
  invalid
}) => {
  const { t } = useTranslation();
  const classNames = [];

  if (!isActive) {
    classNames.push(classes.InActive);
  } else {
    classNames.push(classes.Active);
  }
  if (invalid) {
    classNames.push(classes.Invalid);
  }

  return (
    <Button 
      disabled={disabled} 
      onClick={event => onClick(value)} 
      className={classNames.join(' ')}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: '6px',
        padding: '0.6rem 1.15rem',
        borderRadius: '6px',
        cursor: 'pointer',
        fontSize: '0.95rem',
        transition: 'all 0.15s ease-in-out',
      }}
    >
      {isActive && <span style={{ fontWeight: 800 }}>✓</span>}
      {labelTranslation ? t(labelTranslation) : label}
    </Button>
  );
};

export default RadioButtonOption;
